import { StringColumn, CustomColumn } from 'baseui/data-table';

export const COL_NAMES = {
	key: 'key',
	oldValue: 'oldValue',
	newValue: 'newValue'
};

export const columnConfigs = [
	StringColumn({
		title: 'Key',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.key]
	}),

	CustomColumn({
		title: 'Old Value',
		mapDataToValue: (data: any) => data[COL_NAMES.oldValue],
		maxWidth: 300,
		renderCell: (params: any) => {
			const { value } = params;
			return value;
		}
	}),
	CustomColumn({
		title: 'New Value',
		mapDataToValue: (data: any) => data[COL_NAMES.newValue],
		maxWidth: 300,
		renderCell: (params: any) => {
			const { value } = params;
			return value;
		}
	})
];
